<template>
  <div>
    <b-row v-if="checkAccessPrivilege('Promotion.Referral.Search')">
      <b-col sm="12" md="12">
        <b-card no-body>
          <b-card-header>
              <h5 class="float-left"><i class='fa fa-search'></i> Search</h5>
          </b-card-header>
          <b-card-body>
            <b-form>
              <b-row>
                <b-col sm="3">
                  <label class="mr-sm-2" for="sUsername">Username </label>
                  <b-input id="sUsername" type="text" placeholder="" v-model.trim="sUsername"></b-input>
                </b-col>
                <b-col sm="3">
                  <label class="mr-sm-2" for="sStatus">Status </label>
                  <b-form-select id="sStatus" :plain="true" :options="statusOption" v-model="sStatus" text-field="Name" value-field="Id">
                    <template slot="first">
                      <option :value="null">-- Please select an option --</option>
                    </template>
                  </b-form-select>
                </b-col>
                <b-col sm="3">
                  <label class="mr-sm-2" for="sStartTime">From (yyyy/mm/dd 00:00:00)</label>
                  <b-input id="sStartTime" type="date" placeholder="" v-model.trim="sStartTime"></b-input>
                </b-col>
                <b-col sm="3">
                  <label class="mr-sm-2" for="sEndTime">To (yyyy/mm/dd 23:59:59)</label>
                  <b-input id="sEndTime" type="date" placeholder="" v-model.trim="sEndTime"></b-input>
                </b-col>
              </b-row>
              <br>
              <b-row>
                <b-col sm="4" class="align-self-end">
                  <b-button id="sBtn" variant="primary" @click="search"><i class="fa fa-search"></i> Search</b-button>
                </b-col>
              </b-row>
            </b-form>
          </b-card-body>
        </b-card>
      </b-col>
    </b-row>
    <b-row>
      <b-col sm="12" md="12">
        <b-card no-body>
          <b-card-header>
            <h3 class="float-left"><i class='fa fa-money'></i> Referral Commission Records</h3>
            <b-button class="float-right" variant="primary" @click="exportCSV" :disabled="items.length === 0">Export</b-button>
          </b-card-header>
          <b-card-body>
            <div class="overflow-auto">
              <b-table :hover="hover" :striped="striped" :bordered="bordered" :small="small" :fixed="fixed" responsive="sm" :items="items" :fields="fields">
                <template v-slot:row-details="data">
                  <b-table :hover="hover" :striped="striped" :bordered="bordered" :small="small" :fixed="fixed" responsive="sm" :items="data.item.subItems" :fields="subFields" :current-page="subItemCurrent" :per-page="perPage">
                    <template v-slot:cell(sn)="data">
                      {{data.index+1 + ((subItemCurrent-1)*1)}}
                    </template>
                    <template v-slot:cell(Turnover)="data">
                      {{ format(data.item.Turnover, '0,0.00') }}
                    </template>
                    <template v-slot:cell(Commission)="data">
                      {{ format(data.item.Commission, '0,0.00') }}
                    </template>
                    <template v-slot:cell(TotalCommission)="data">
                      {{ getTotalCommission(data.item) }}
                    </template>
                    <template v-slot:cell(ExtraCommission)="data">
                      {{ format(data.item.ExtraCommission, '0,0.00') }}
                    </template>
                  </b-table>
                  <nav>
                    <b-pagination :total-rows="getSubItemRowCount(data.item.subItems)" :per-page="perPage" v-model="subItemCurrent" prev-text="Prev" next-text="Next" hide-goto-end-buttons/>
                  </nav>
                </template>
                <template v-slot:cell(Operate)="data">
                  <b-btn variant="success" class="btn-sm" @click="getDetail(data.item)">
                    <i v-if="!data.item._showDetails" class="fa fa-chevron-right"></i>
                    <i v-else class="fa fa-chevron-down"></i>
                  </b-btn>
                </template>
                <template v-slot:cell(Turnover)="data">
                  {{ format(data.item.Turnover, '0,0.00') }}
                </template>
                <template v-slot:cell(Commission)="data">
                  {{ format(data.item.Commission, '0,0.00') }}
                </template>
                <template v-slot:cell(TotalCommission)="data">
                  {{ getTotalCommission(data.item) }}
                </template>
                <template v-slot:cell(ExtraCommission)="data">
                  {{ format(data.item.ExtraCommission, '0,0.00') }}
                </template>
                <template v-slot:cell(Status)="data">
                  <b-badge variant="warning" v-if="data.item.Status === 0">Created</b-badge>
                  <b-badge variant="info" v-if="data.item.Status === 1">Processing</b-badge>
                  <b-badge variant="success" v-if="data.item.Status === 2">Success</b-badge>
                  <b-badge variant="danger" v-if="data.item.Status === 3">Failed</b-badge>
                  <b-badge variant="success" v-if="data.item.Status === 4">Manual Handle</b-badge>
                </template>
                <template v-slot:cell(Type)="data">
                  <b-badge variant="success" v-if="data.item.Type === 1">Referee</b-badge>
                  <b-badge variant="success" v-if="data.item.Type === 2">Referrer</b-badge>
                </template>
                <template v-slot:cell(RefId)="data">
                  <span v-if="data.item.Type === 1">Referred By<br/>{{ data.item.RefId }}</span>
                  <span v-if="data.item.Type === 2">Referred To<br/>{{ data.item.RefId }}</span>
                </template>
                <template v-slot:cell(MarkOperator)="data">
                  <b-button variant="danger" class="btn-sm" v-if="[0, 1, 3].includes(data.item.Status) && checkAccessPrivilege('Promotion.ReferralCommission.Redeem')" @click="confirm(data.item)">Settle</b-button>
                  <span v-else-if="data.item.Status === 4">{{ data.item.MarkOperator }}</span>
                </template>
              </b-table>
              <nav>
                <b-pagination :total-rows="getRowCount(items)" :per-page="perPage" v-model="currentPage" prev-text="Prev" next-text="Next" hide-goto-end-buttons/>
              </nav>
            </div>
          </b-card-body>
        </b-card>
      </b-col>
    </b-row>
    <b-modal ref="confirm" size="lg" centered header-bg-variant="primary" hide-footer title="Redeem This Ticket">
      <div class="mb-3">
        Are you sure?
      </div>
      <b-button variant="success" @click="redeemTicket">Yes</b-button>
      <b-button variant="outline-danger" @click="cancelRedeem">Cancel</b-button>
    </b-modal>
  </div>
</template>

<script>
  import VueNotifications from 'vue-notifications'
  import {Events} from '../../../events.js'
  import numeral from 'numeral'
  import moment from 'moment-timezone'

  export default {
    name: 'referral-member-list',
    props: {
      caption: {
        type: String,
        default: 'Table'
      },
      hover: {
        type: Boolean,
        default: false
      },
      striped: {
        type: Boolean,
        default: false
      },
      bordered: {
        type: Boolean,
        default: false
      },
      small: {
        type: Boolean,
        default: false
      },
      fixed: {
        type: Boolean,
        default: false
      }
    },
    data: () => {
      return {
        items: [],
        statusOption: [
          { Id: '0', Name: 'Created' },
          { Id: '1', Name: 'Processing' },
          { Id: '2', Name: 'Success' },
          { Id: '3', Name: 'Failed' },
          { Id: '4', Name: 'Manual Handle' }
        ],
        fields: [
          {key: 'Operate', label: 'Operate'},
          {key: 'CommissionDate', label: 'Date'},
          {key: 'Username', label: 'Username'},
          {key: 'Turnover', label: 'Turnover'},
          {key: 'Commission', label: 'Commission'},
          {key: 'ExtraCommission', label: 'Extra Commission'},
          {key: 'TotalCommission', label: 'Total Commission'},
          {key: 'Status', label: 'Status'},
          {key: 'MarkOperator', label: 'Mark Operator'}
        ],
        subFields: [
          {key: 'sn', label: 'S.No'},
          {key: 'Username', label: 'Username'},
          {key: 'Turnover', label: 'Turnover'},
          {key: 'Commission', label: 'Commission'},
          {key: 'ExtraCommission', label: 'Extra Commission'},
          {key: 'TotalCommission', label: 'Total Commission'}
        ],
        subItemCurrent: 1,
        currentPage: 1,
        rowCount: 0,
        perPage: 20,
        operator: '',
        sUsername: '',
        sStatus: null,
        sStartTime: moment().tz('Asia/Taipei').subtract(7, 'days').format('YYYY-MM-DD'),
        sEndTime: moment().tz('Asia/Taipei').format('YYYY-MM-DD'),
        redeemData: {
          memberId: '',
          date: ''
        }
      }
    },
    watch: {
      currentPage: function () {
        this.search()
      }
    },
    methods: {
      getRowCount () {
        return this.rowCount
      },
      getSubItemRowCount (item) {
        return item.length
      },
      format (num, fmt) {
        return numeral(num).format(fmt)
      },
      getTotalCommission (item) {
        return this.format(parseFloat(item.Commission) + parseFloat(item.ExtraCommission), '0,0.00')
      },
      async exportCSV () {
        let username = this.sUsername
        let status = this.sStatus || ''
        let startTime = this.sStartTime
        let endTime = this.sEndTime
        Events.$emit('loader')
        let queryStr = `?username=${username}&startTime=${startTime}&endTime=${endTime}&status=${status}`
        try {
          const response = await this.$http.get(this.API_ENDPOINT + '/promotion/referral/commission/records/search/export' + queryStr, {responseType: 'blob', headers: { 'Content-Type': 'application/json' }})
          const url = window.URL.createObjectURL(new Blob([response.data]))
          const link = document.createElement('a')
          link.href = url
          link.setAttribute('download', `referral_commission_${moment(this.startTime).format('YYYYMMDD')}_${moment(this.endTime).format('YYYYMMDD')}.csv`)
          document.body.appendChild(link)
          link.click()
          Events.$emit('loader')
        } catch (err) {
          Events.$emit('loader')
          console.log('this is an error ', err)
          Events.$emit('alert', VueNotifications.types.error, 'Error', 'Something went wrong')
        }
      },
      async search () {
        let username = this.sUsername
        let status = this.sStatus || ''
        let startTime = this.sStartTime
        let endTime = this.sEndTime
        let page = this.currentPage
        let size = this.perPage
        Events.$emit('loader')

        let queryStr = `?username=${username}&startTime=${startTime}&endTime=${endTime}&status=${status}&size=${size}&page=${page}`
        try {
          const response = await this.$http.get(this.API_ENDPOINT + '/promotion/referral/commission/records/search' + queryStr, {headers: { 'Content-Type': 'application/json' }})
          this.items = response.data.result
          this.rowCount = response.data.rowCount
          Events.$emit('loader')
        } catch (err) {
          Events.$emit('loader')
          console.log('this is an error ', err)
          Events.$emit('alert', VueNotifications.types.error, 'Error', 'Something went wrong')
        }
      },
      async getDetail (item) {
        try {
          Events.$emit('loader')
          this.subItemCurrent = 1
          if (item._showDetails) {
            item._showDetails = false
            return
          } else {
            let payload = {
              memberId: item.MemberId,
              date: item.CommissionDate
            }
            let { data } = await this.$http.post(this.API_ENDPOINT + '/promotion/referral/commission/getRecords/details', payload, { headers: { 'Content-Type': 'application/json' } })
            item.subItems = data.result
            this.items.forEach(x => { this.$set(x, '_showDetails', false) })
            this.$set(item, '_showDetails', true)
          }
        } catch (err) {
          console.log('this is an error ', err)
          Events.$emit('alert', VueNotifications.types.error, 'Error', 'Something went wrong')
        } finally {
          Events.$emit('loader')
        }
      },
      async redeemTicket () {
        try {
          let response = await this.$http.post(this.API_ENDPOINT + '/promotion/referral/commission/records/mark', { memberId: this.redeemData.memberId, date: this.redeemData.date }, { headers: { 'Content-Type': 'application/json' } })
          if (response.status === 200) {
            this.search()
            this.cancelRedeem()
            Events.$emit('alert', VueNotifications.types.success, 'Success', 'Referral Commission Settled.')
          }
        } catch (err) {
          console.log('this is an error ', err)
          Events.$emit('alert', VueNotifications.types.error, 'Error', 'Something went wrong')
        }
      },
      confirm (item) {
        this.redeemData.memberId = item.MemberId
        this.redeemData.date = item.CommissionDate
        this.$refs.confirm.show()
      },
      cancelRedeem () {
        this.redeemData.memberId = ''
        this.redeemData.date = ''
        this.$refs.confirm.hide()
      },
      checkAccessPrivilege (module) {
        if (!module) return true
        return this.PRIVILEGE.includes(module)
      }
    },
    created () {
      let user = JSON.parse(window.sessionStorage.getItem('user'))
      this.operator = user.username
    }
  }
</script>



// WEBPACK FOOTER //
// src/views/promotion/referralCommission/ReferralCommissionTable.vue